import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
import { useAudio } from '../../context/AudioContext';
import './AudioVisualizer.css';

const AudioVisualizer = () => {
  const { isPlaying, isEnabled, toggleMusic } = useAudio();
  const [showIcon, setShowIcon] = useState(false);
  const [autoPlayBlocked, setAutoPlayBlocked] = useState(false);

  // Check if auto-play was blocked
  useEffect(() => {
    const blocked = localStorage.getItem('autoPlayBlocked') === 'true';
    setAutoPlayBlocked(blocked);
  }, []);

  if (!isEnabled) return null;

  return (
    <div 
      className="audio-visualizer"
      data-autoplay-blocked={autoPlayBlocked}
      onMouseEnter={() => setShowIcon(true)}
      onMouseLeave={() => setShowIcon(false)}
      onClick={() => {
        toggleMusic();
        // Clear auto-play blocked flag when user manually interacts
        if (autoPlayBlocked) {
          localStorage.removeItem('autoPlayBlocked');
          setAutoPlayBlocked(false);
        }
      }}
      title={isPlaying ? 'Pause background music' : 'Play background music'}
    >
      {/* EQ Bars */}
      <div className="eq-bars">
        {[1, 2, 3, 4, 5].map((bar, index) => (
          <div
            key={index}
            className={`eq-bar eq-bar-${index + 1} ${isPlaying ? 'playing' : 'paused'}`}
          />
        ))}
      </div>
      
      {/* Play/Pause Icon Overlay */}
      <div className={`play-pause-icon ${showIcon ? 'visible' : ''}`}>
        <FontAwesomeIcon 
          icon={isPlaying ? faPause : faPlay} 
          size="sm"
        />
      </div>
    </div>
  );
};

export default AudioVisualizer; 